module.exports = __webpack_public_path__ + "img/ile-loisirs.bb62d221.jpg";